const banner = {
  imgPath: "图片",
  linkPath: "链接路径",
  selectImg: "选择图片",
  error1: "请选择图片",
  error2: "请输入描述",
  addbanner: "新增网幅广告",
  editbanner: "编辑网幅广告"
} 
export default banner